/**
 * Created by DynamicDog on 2016-12-13.
 *
 * Simple translation pipe that just calls the translation service and returns whatever response it gets.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service'; // our translate service

@Pipe({
    name: 'translate'
})

export class TranslatePipe implements PipeTransform {
    constructor(private _translate: TranslateService) { }

    transform(value: string, args: any[]): any {
        if (!value) return;
        return this._translate.translate(value);
    }
}


// WEBPACK FOOTER //
// ./app/pipes/translate.pipe.ts